import React from 'react';
import PropTypes from 'prop-types';
import Logo from 'static/assets/images/granicus-logo-mono-white.png';
import toCamelCase from 'lib/camel-case';
import { withTranslation } from 'next-i18next';

const FooterLayoutOne = ({
  backgroundColor,
  data,
  textColor,
  fontFamily,
  links,
  t,
}) => {
  const socialLinksNode = () => {
    const {
      facebookUrl,
      twitterUrl,
      googleUrl,
      linkedinUrl,
      instagramUrl,
      youtubeUrl,
    } = data;

    if (
      !facebookUrl &&
      !twitterUrl &&
      !googleUrl &&
      !linkedinUrl &&
      !instagramUrl &&
      !youtubeUrl
    )
      return false;

    return (
      <div className="ehq-participant-footer__social-links">
        {[
          {
            key: 'facebookUrl',
            icon: 'fa-brands fa-square-facebook fa-lg',
            link: facebookUrl,
            label: t('editor:editor.facebookLink'),
          },
          {
            key: 'twitterUrl',
            icon: 'fa-brands fa-x-twitter fa-lg',
            link: twitterUrl,
            label: t('editor:editor.twitterLink'),
          },
          {
            key: 'googleUrl',
            icon: 'fa-brands fa-google fa-lg',
            link: googleUrl,
            label: t('editor:editor.googleLink'),
          },
          {
            key: 'linkedinUrl',
            icon: 'fa-brands fa-linkedin fa-lg',
            link: linkedinUrl,
            label: t('editor:editor.linkedinLink'),
          },
          {
            key: 'instagramUrl',
            icon: 'fa-brands fa-instagram fa-lg',
            link: instagramUrl,
            label: t('editor:editor.instagramLink'),
          },
          {
            key: 'youtubeUrl',
            icon: 'fa-brands fa-youtube fa-lg',
            link: youtubeUrl,
            label: t('editor:editor.youtubeUrl'),
          },
        ].map(({ link, key, icon, label }) => {
          if (!link) return false;

          return (
            <div
              key={key}
              className="ehq-participant-footer__social-links__link"
            >
              <a
                href={link}
                aria-label={label}
                className="ehq-participant-footer__social-links__link__anchor"
              >
                <span className={icon} />
              </a>
            </div>
          );
        })}
      </div>
    );
  };

  const translateLinks = (link) => {
    const camelCasedLink = toCamelCase(link);

    const defaultLinks = [
      'termsAndConditions',
      'privacyPolicy',
      'moderationPolicy',
      'accessibility',
      'technicalSupport',
      'cookiePolicy',
      'siteMap',
    ];

    const isDefaultLink = defaultLinks.indexOf(camelCasedLink);

    if (isDefaultLink >= 0) {
      return t(`footer:footer.${camelCasedLink}`);
    }

    return link;
  };

  const getLinkUrl = (item) => {
    switch (item.linkableType) {
      case 'Hub':
      case 'Project':
      case 'StaticPage':
        return `/${item.linkableUrl}`;

      default:
        return item.linkableUrl;
    }
  };

  const staticPagesLinksNode = () => {
    if (!links.length) return false;

    return (
      <div className="ehq-participant-footer__static-pages">
        {links.map((link, index) => {
          return (
            <div
              key={index}
              className="ehq-participant-footer__static-pages__link"
            >
              <a href={getLinkUrl(link)}>{translateLinks(link.title)}</a>
            </div>
          );
        })}
      </div>
    );
  };

  const logoNode = () => {
    if (!Logo) return false;

    return (
      <div className="ehq-participant-footer__logo">
        <a href="https://granicus.com">
          <img
            alt={t('editor:editor.poweredByEngagementHq')}
            src={Logo}
            width="150"
            height="50"
          />
        </a>
      </div>
    );
  };

  return (
    <div
      className="ehq-participant-footer"
      style={{
        backgroundColor,
        color: textColor,
        fontFamily,
      }}
    >
      {socialLinksNode()}
      {staticPagesLinksNode()}
      {logoNode()}
    </div>
  );
};

FooterLayoutOne.propTypes = {
  backgroundColor: PropTypes.string,
  data: PropTypes.object,
  links: PropTypes.array,
  textColor: PropTypes.string,
  fontFamily: PropTypes.string,
  fontWeight: PropTypes.number,
  meta: PropTypes.object,
  brandColor: PropTypes.string,
};

export default withTranslation(['footer', 'editor'])(FooterLayoutOne);
